import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import * as _ from 'lodash';
import { Tree } from 'ng2-tree';

import { LocationTree } from '../models/location-tree';
import { HttpService } from '../../../../../services/http.service';

@Injectable()
export class LocationService extends HttpService {
  public locationHierarchy: LocationTree;
  public editdata: LocationTree = <LocationTree>{};

  getLocationHierarchy() {
    let requestOptionsArgs = {};
    return this.getApi('/location-hierarchy/user-access', requestOptionsArgs, 'location-hierarchy')
      .map(res => <LocationTree>res.json().result)
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/shared/components/location-hierarchy/services/location-hierarchy.service.ts